import { ApiDateFilter } from "@/components/date-filter/date-filter.type.ts";
import {
  ApiEmployeeColumn,
  ApiEmployeeColumnFilter,
} from "@/types/employees/employee-column.types.ts";
import { TFunction } from "i18next";

export function formatColumnFilterValue(
  filter: ApiEmployeeColumnFilter,
  column: ApiEmployeeColumn,
  t: TFunction,
  formatRange: (dateFilter: ApiDateFilter | undefined) => string | undefined
): string | undefined {
  if (filter.is_empty !== undefined) {
    return filter.is_empty ? t("core:column_filter_is_empty") : t("core:column_filter_is_filled");
  }
  if (filter.option_ids?.length) {
    const titles = filter.option_ids
      .map((id) => column.options?.find((option) => option.id === id)?.title)
      .filter((title): title is string => Boolean(title));
    return titles.length ? titles.join(", ") : String(filter.option_ids.length);
  }
  if (filter.employee_ids?.length) {
    return String(filter.employee_ids.length);
  }
  if (filter.date_filter) return formatRange(filter.date_filter);
  if (filter.switch !== undefined) {
    return filter.switch ? t("common:yes") : t("common:no");
  }
  if (filter.number_from !== undefined || filter.number_to !== undefined) {
    return [filter.number_from, filter.number_to]
      .map((part) => (part === undefined ? "…" : String(part)))
      .join(" — ");
  }
  if (filter.text?.trim()) return filter.text.trim();
  if (filter.text_array?.length) return filter.text_array.join(", ");
  return undefined;
}
